module.exports = __webpack_public_path__ + "img/icon_toast_success.7d02076a.png";